(() => {
  /**
   * Uses Swiper package to create a carousel
   * More info: https://swiperjs.com/
   */
  if (customElements.get('featured-blog')) {
    return;
  }

  class FeaturedBlog extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;

      this.options = {
        navigation: {
          prevEl: this.querySelector('[data-arrow-prev]'),
          nextEl: this.querySelector('[data-arrow-next]'),
        },
        slidesPerView: 1,
        spaceBetween: 5,
        breakpoints: {
          750: {
            slidesPerView: 2,
          },
          1200: {
            slidesPerView: 3,
          },
        },
      };

      this.slider = new Swiper(this.querySelector('[data-slider]'), this.options);
    }
  }

  customElements.define('featured-blog', FeaturedBlog);
})();
